import { render, staticRenderFns } from "./TaskAppliers.vue?vue&type=template&id=4d10e353&scoped=true&"
import script from "./TaskAppliers.vue?vue&type=script&lang=ts&"
export * from "./TaskAppliers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d10e353",
  null
  
)

export default component.exports